/* The order a person reads a list of rooms in.

   Room numbers are free text, and the houses mix numbered rooms with named
   ones — 101-516 and 1-32 alongside Suite, Lawn, Meeting Hall, D.Hall, LD-1.
   Numbered rooms lead, in natural numeric order; named rooms follow
   alphabetically. This mirrors guesthouses/room_order.py on the backend, so a
   list sorted here and the same list sorted there agree.

   `numeric` is what keeps "2" ahead of "10" (and LD-2 ahead of LD-10);
   `sensitivity: 'base'` stops casing from splitting otherwise-equal names.
   Both match the collator in context/BookingContext.js. */
const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

/* Leading punctuation and spaces are ignored when deciding which of the two
   blocks a room is in, so " 101" still counts as numbered. */
const NON_ALNUM = /[^A-Za-z0-9]+/g;

function isNamed(roomNumber) {
  const normalized = (roomNumber || "").replace(NON_ALNUM, "");
  return /[0-9]/.test(normalized.charAt(0)) ? 0 : 1;
}

/* Compare two room numbers. */
export function compareRoomNumbers(a, b) {
  return isNamed(a) - isNamed(b) || collator.compare(a || "", b || "");
}

/* Compare two room-assignment objects: guest house first, then room number.

   The house leads because a booking can hold rooms in more than one of them (a
   sub-request), and a reader walks such a list house by house rather than
   interleaving two buildings' room numbers. */
export function byRoomOrder(a, b) {
  return (
    collator.compare(a?.guest_house_name || "", b?.guest_house_name || "") ||
    compareRoomNumbers(a?.room_number, b?.room_number)
  );
}
